import { ACTIVE_BOOKING_URL } from "@/config/bookingLinks.js";
import { OPEN_COOKIE_PREFERENCES_EVENT } from "./CookieConsent";
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="w-full pt-1 pb-24 md:pb-16"
      style={{
        background:
          "linear-gradient(180deg, #F8F5EF 0%, #F5F0E8 45%, #F2EDE4 100%)",
      }}
    >
      {/* Gradient top divider */}
      <div
        className="h-[2px] w-full mb-14"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(107,116,47,0.5) 20%, rgba(180,160,90,0.6) 45%, rgba(180,166,227,0.55) 75%, transparent 100%)",
          opacity: 0.7,
        }}
      />

      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Brand */}
          <div>
            <a
              href="/"
              className="flex justify-center mb-6 cursor-pointer"
              aria-label="Perspective Therapy home"
            >
              <img
                src="/images/brand/Perspective-Therapy-Logo.png"
                alt="Perspective Therapy"
                className="h-20 w-auto object-contain"
              />
            </a>

            <p className="font-manrope text-[#2B2B2B]/75 text-[15px] leading-relaxed mb-5 max-w-xs">
              In-person therapy in Larchmont, New York, and telehealth in New
              York, New Jersey, and Indiana for children, teens, adults,
              couples, and groups. Therapist eligibility varies.
            </p>

            <div className="flex gap-3 mb-6">
              {[
                {
                  icon: "ri-instagram-line",
                  label: "Instagram",
                  href: "https://www.instagram.com/perspectivetherapyny",
                },
                {
                  icon: "ri-facebook-circle-line",
                  label: "Facebook",
                  href: "https://www.facebook.com/people/Perspective-Therapy/61572358177918/",
                },
                {
                  icon: "ri-tiktok-line",
                  label: "TikTok",
                  href: "https://www.tiktok.com/@perspectivetherapy",
                },
                {
                  icon: "ri-threads-line",
                  label: "Threads",
                  href: "https://www.threads.com/@perspectivetherapyny",
                },
                {
                  icon: "ri-twitter-x-line",
                  label: "X",
                  href: "https://x.com/prspctvtherapy",
                },
                {
                  icon: "ri-linkedin-box-line",
                  label: "LinkedIn",
                  href: "https://www.linkedin.com/company/perspective-therapy-mental-health-counseling-pllc/?viewAsMember=true",
                },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-[#2B2B2B]/8 hover:bg-[#3C6FF8]/15 text-[#2B2B2B]/50 hover:text-[#3C6FF8] transition-all cursor-pointer"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>

            <a
              href={ACTIVE_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#3C6FF8] hover:bg-[#2a5de6] text-white font-manrope font-semibold text-[13px] px-5 py-2.5 rounded-full cursor-pointer whitespace-nowrap transition-colors"
            >
              Schedule a Session
            </a>

            <div className="mt-5 flex flex-wrap gap-x-5 gap-y-1">
              {[
                ["Privacy Policy", "/privacy-policy"],
                ["Terms & Conditions", "/terms-conditions"],
              ].map(([label, href]) => (
                <a
                  key={label}
                  href={href}
                  className="font-manrope text-[13px] text-[#2B2B2B]/60 hover:text-[#2B2B2B]/85 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {label}
                </a>
              ))}
              <button
                type="button"
                onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT))}
                className="font-manrope text-[13px] text-[#2B2B2B]/60 hover:text-[#2B2B2B]/85 transition-colors cursor-pointer whitespace-nowrap"
              >
                Cookie Preferences
              </button>
            </div>
          </div>

          {/* Services */}
          <div>
            <h5
              className="font-manrope text-[13px] font-semibold tracking-widest uppercase mb-4"
              style={{ color: "#6B742F" }}
            >
              Services
            </h5>

            <ul className="flex flex-col gap-2.5">
              {[
                ["Individual Therapy", "/individual-therapy"],
                ["Couples Therapy", "/couples-therapy"],
                ["Teen Therapy", "/teen-therapy"],
                ["Child Therapy", "/child-therapy"],
                ["Group Therapy", "/group-therapy"],
                ["Telehealth Sessions", "/#how-it-works"],
                ["In-Person (Larchmont)", "/#how-it-works"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="font-manrope text-[15px] text-[#2B2B2B]/75 hover:text-[#2B2B2B] transition-colors cursor-pointer"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Practice */}
          <div>
            <h5
              className="font-manrope text-[13px] font-semibold tracking-widest uppercase mb-4"
              style={{ color: "#6B742F" }}
            >
              Practice
            </h5>

            <ul className="flex flex-col gap-2.5">
              {[
                ["About Us", "/about"],
                ["Find a Therapist", "/therapists"],
                ["How It Works", "/#how-it-works"],
                ["Rates & Insurance", "/full-pricing"],
                ["FAQ", "/#faq"],
                ["Contact", "/contact"],
                ["Blog", "/blog"],
                ["Sitemap", "/sitemap"],
                ["Store", "https://thehealingspree.com"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    className="font-manrope text-[15px] text-[#2B2B2B]/75 hover:text-[#2B2B2B] transition-colors cursor-pointer"
                    target={href.startsWith("http") ? "_blank" : undefined}
                    rel={
                      href.startsWith("http")
                        ? "nofollow noopener noreferrer"
                        : undefined
                    }
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5
              className="font-manrope text-[13px] font-semibold tracking-widest uppercase mb-4"
              style={{ color: "#6B742F" }}
            >
              Contact
            </h5>

            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-[#3C6FF8] text-sm"></i>
                </span>
                <span className="font-manrope text-[15px] text-[#2B2B2B]/75 leading-snug">
                  4 Gilder Street, Suite 2
                  <br />
                  Larchmont, NY 10538
                </span>
              </li>

              <li className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-[#3C6FF8] text-sm"></i>
                </span>
                <a
                  href="tel:+18389108150"
                  className="font-manrope text-[15px] text-[#2B2B2B]/75 hover:text-[#2B2B2B] transition-colors cursor-pointer"
                >
                  (838) 910-8150
                </a>
              </li>

              <li className="flex items-center gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-[#3C6FF8] text-sm"></i>
                </span>
                <a
                  href="mailto:Info@perspectivetherapyNY.com"
                  className="font-manrope text-[15px] text-[#2B2B2B]/75 hover:text-[#2B2B2B] transition-colors cursor-pointer break-words"
                >
                  Info@perspectivetherapyNY.com
                </a>
              </li>

              <li className="flex items-start gap-2.5">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-time-line text-[#3C6FF8] text-sm"></i>
                </span>
                <span className="font-manrope text-[15px] text-[#2B2B2B]/75 leading-snug">
                  Mon–Fri: 9am – 9pm
                  <br />
                  Sat &amp; Sun: 10am – 4pm
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="border-t pt-6"
          style={{ borderColor: "rgba(203,191,175,0.35)" }}
        >
          <p className="font-manrope text-[13px] text-[#2B2B2B]/60 text-center sm:text-left">
            &copy; {year} Perspective Therapy Mental Health Counseling, PLLC.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
